import axios from "./axios";
import { API_ID, API_KEY, CREATE_REQUEST_HELP, GENERATE_WITHDRAWAL_TOKEN, PRTNRID } from "./APILinks";

export const apiCreateRequestHelp = (message, transactionId) =>
  axios.post(CREATE_REQUEST_HELP, {
    message,
    transactionId,
  });

export const apiCreateKocekOutToken = () => {
  return axios.post(
    GENERATE_WITHDRAWAL_TOKEN,
    {
      apiId: API_ID,
      apiKey: API_KEY,
    },
    {
      headers: {
        prtnrId: PRTNRID,
      },
    }
  );
};
